/*Gift Ship mods*/
document.addEventListener('DOMContentLoaded', function () {
  if(document.querySelector('#gsMultishippingPage')){
    
    addAttribute();

    const cart = JSON.parse(document.querySelector('#gsCartJson').textContent);

    document.addEventListener('click', function (event) {
      if (event.target.matches('.gs__saved-address-item') || event.target.parentNode.matches('.gs__saved-address-item')) {
        setTimeout(() => {
          addressSelect(event.target.closest('.gs__saved-address-item'));
        }, 100);
      }

      if (event.target.matches('.gs__address-complete')) {
        const line = document.querySelector('.gs__a-modal').dataset.line;
        setTimeout(() => {
          addressSelect(document.querySelector(`.gs__dropdown[data-line="${line}"] .gs__saved-address-item:last-child`));
        }, 3000);
      }
      
    });

    async function addAttribute(){
      //add multiship cart attribute
      const updateRequest = {
        method: "POST",
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With':'xmlhttprequest'
        },
        body: JSON.stringify({
          attributes: {
            'multiship': true
          }
        })
      }; 

      await fetch("/cart/update.js", updateRequest)
        .then((response) => {
          return response.json();
        })
        .then((json) => {
          console.log("multiship cart attribute added");
        })
        .catch((e) => {
          console.error(e);
        });
    }

    async function addressSelect(element){
      console.log("addressSelect");
      const address = element.dataset.value;
      const _gs_a = JSON.parse(element.dataset.address);
      const line = element.closest('.gs__dropdown').dataset.line;
      const key = element.closest('.gs__dropdown').dataset.key;

      let cart = await fetch("/cart.js")
        .then((response) => {
          return response.json();
        })
        .then((json) => {
          return json;
        })
        .catch((e) => {
          console.error(e);
        });

      let cart_item = false;
      for(const item of cart.items){
        if(item.key == key){
          cart_item = item;
          break;
        }
      }

      if(!cart_item || !cart_item.properties._bundle_selection) return;

      const variantId = cart_item.variant_id;
      const existingProps = cart_item.properties;
      const quantity = cart_item.quantity;
      let newProps = existingProps;
      newProps["Address"] = address;
      newProps["_gs_a"] = _gs_a;

      //console.log(key);
      //console.log(line)
      //console.log(variantId)
      //console.log(quantity)
      //console.log(newProps)
      document.querySelector(`.gs__search-input[data-line="${line}"]`).value = address;
      document.querySelector(`.gs__dropdown > label`).style.display = "none";

      waitForElm('#gsGroups:not(.gs__blocked)').then((elm) => {
        document.querySelector('#gsGroups').classList.add('gs__blocked');
        document.querySelector(`.gs__search-input[data-line="${line}"]`).value = address;
        document.querySelector(`.gs__dropdown > label`).style.display = "none";
        reAddItem(key, line, variantId, quantity, newProps, address);
      });
    }

    async function reAddItem(key, line, variantId, quantity, properties, address){
      const removeRequest = {
        method: "POST",
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With':'xmlhttprequest'
        },
        body: JSON.stringify({
          'id': key,
          'quantity': 0,
        })
      }; 

      await fetch("/cart/change.js", removeRequest)
        .then((response) => {
          return response.json();
        })
        .then((json) => {
          console.log("removed");
          console.log(json);
        })
        .catch((e) => {
          console.error(e);
          document.querySelector('#gsGroups').classList.remove('gs__blocked');
        });

      const addRequest = {
        method: "POST",
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With':'xmlhttprequest'
        },
        body: JSON.stringify({
          'items': [
            {
              'quantity': quantity,
              'id': variantId,
              'properties': properties
            }
          ]
        })
      };

      await fetch("/cart/add.js", addRequest)
        .then((response) => {
          return response.json();
        })
        .then((json) => {
          console.log("added");
          console.log(json);
        })
        .catch((e) => {
          console.error(e);
          document.querySelector('#gsGroups').classList.remove('gs__blocked');
        });

      document.querySelector('#gsGroups').classList.remove('gs__blocked');
      document.querySelector(`.gs__search-input[data-line="${line}"]`).value = address;
      document.querySelector(`.gs__dropdown > label`).style.display = "none";
    }
  }
});


function waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                observer.disconnect();
                resolve(document.querySelector(selector));
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}